import React from "react";
import Style from "./header.module.scss";
import { NavLink, Link } from "react-router-dom";
import logo from "./img/logo.png";
import Config from "../../config";
import { Dropdown, Icon, Menu, Modal } from "antd";
import Navigation from "./component/Navigation";
import Storage from "../../utils/Storage";
import useStorage from "../../utils/useStorage";
import { getLoginUnifySet, LoginType } from "../../service/auth";
import useRequest from "../../utils/useRequest";

interface Props {
    counts?: number; //通知数量
    style?: React.CSSProperties | undefined;
    navIsShow?: boolean;
}
const Header = ({ style, counts, navIsShow = true }: Props) => {
    const [loginUnifySet] = useRequest(getLoginUnifySet);

    const [loginType] = useStorage("LoginType");
    const [teacherNo] = useStorage("teacherNo");

    function onLogout() {
        Modal.confirm({
            title: "提示",
            content: "确定要退出登录吗?",
            onOk: () => {
                Storage.clear();

                if (loginType === LoginType.Form) {
                    window.location.href = `/login`;
                } else {
                    window.location.href = `${Config.CasUrl}/auth/user/logout?client_id=${loginUnifySet?.clientId}`;
                }
            }
        });
    }

    function changePwd() {
        if (loginType === LoginType.Form) {
            window.location.href = "/changepwd";
        } else {
            window.location.href = loginUnifySet?.changePasswordUrl || "";
        }
    }

    const menu = (
        <Menu className={Style.Menu}>
            <Menu.Item>
                <button
                    type="button"
                    onClick={changePwd}
                    className={Style.MenuItem}>
                    <Icon type="setting" /> 修改密码
                </button>
            </Menu.Item>
            <Menu.Item>
                <button
                    type="button"
                    onClick={onLogout}
                    className={Style.MenuItem}>
                    <Icon type="poweroff" /> 退出登录
                </button>
            </Menu.Item>
        </Menu>
    );

    // 本地存储格式变了, 需要重新登录
    if (!teacherNo) {
        window.location.href = `/login`;
    }

    return (
        <div className={Style.header} style={style}>
            <div className={Style.logo}>
                <Link to="/">
                    <img src={logo} alt="Dufe" />{" "}
                    <span className={Style.logoText}>{Config.Title}</span>
                </Link>
            </div>

            <div className={Style.Navigation}>
                {navIsShow && <Navigation counts={counts} />}
            </div>

            <div className={Style.toolbar}>
                <div className={Style.more}>
                    <div className={Style.moreText}>更多...</div>
                    <div className={Style.moreNavs}>
                        {navIsShow && (
                            <Link
                                type="primary"
                                target="_blank"
                                className={Style.help}
                                to="/resource">
                                资源库
                            </Link>
                        )}
                        {navIsShow && (
                            <NavLink
                                activeClassName={Style.answerStore}
                                className={Style.help}
                                to="/answerStore"
                                target="_blank">
                                题库
                            </NavLink>
                        )}
                        <a
                            href="https://www.edufe.com.cn/bgyhelp/tea/"
                            className={Style.help}
                            target="_blank">
                            帮助
                        </a>
                    </div>
                </div>
                <Dropdown overlay={menu}>
                    <div className={Style.Dropdown}>
                        <span className={Style.Name}>{teacherNo}</span>
                    </div>
                </Dropdown>
            </div>
        </div>
    );
};

export default Header;
